var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"n"},[_vm._v(" "+_vm._s(_vm.translated!=='' && _vm.translated!=null ? _vm.translated : this.translate[0].data.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }